import { AnimateOnScrolledTo } from '@web/components/AnimateOnScrolledTo'

export default function FeaturesSection() {
  const items = [
    {
      title: 'See where your risk actually is',
      image: '/website/eye.svg',
    },
    {
      title: 'Priotise investment',
      image: '/website/reorder.svg',
    },
    {
      title: 'Build defensible business cases',
      image: '/website/protected.svg',
    },
    {
      title: 'Communicate risk to communities and stakeholders',
      image: '/website/communicate.svg',
    },
  ]

  return (
    <section className="bg-neutral-muted py-16 md:py-24">
      <div className="flex flex-col mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-16 text-2xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
          See where your risk is. Work out what to do about it.
        </h2>
        <div className="grid mt-8 grid-cols-2 lg:grid-cols-4 -mx-8 gap-y-12">
          {items.map((item, index) => (
            <AnimateOnScrolledTo
              key={index}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center px-8 gap-2 lg:gap-4 relative"
            >
              <div className="min-h-32 w-full flex flex-col items-center justify-center">
                <img alt="" src={item.image} className="object-fit object-center" />
              </div>
              <h3 className="text-lg leading-tight font-semibold text-brand-blue text-center max-w-[200px]">
                {item.title}
              </h3>
              {index < items.length - 1 && (
                <div className="min-w-1 h-full absolute top-0 right-0 rounded-full bg-brand-blue hidden lg:block" />
              )}
            </AnimateOnScrolledTo>
          ))}
        </div>
      </div>
    </section>
  )
}
